export const formatDate = (dateStr) => {
  const date = new Date(dateStr);

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
export const formatDateNum = (dateStr) => {
  const date = new Date(dateStr);

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
  });
};


export const getDateRange = (days = 365, fromDate = null) => {
  const format = (d) =>
    new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];

  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  // 🔹 Normal min/max (today based)
  const minDate = format(today);

  const maxDateObj = new Date(today);
  maxDateObj.setDate(today.getDate() + days);
  const maxDate = format(maxDateObj);

  // 🔹 fromDate based max (for toDate)
  let fromToMaxDate = "";

  if (fromDate) {
    const from = new Date(fromDate);
    const temp = new Date(from);
    temp.setDate(from.getDate() + days);
    fromToMaxDate = format(temp);
  }

  return {
    minDate,        
    maxDate,        
    fromToMaxDate,  
  };
};